import React from 'react'
import RenderIf from '../render-if/Renderif';
import ErrorMessage from './ErrorMessage';
import {
    inputFieldClasses,
    inputFieldStyleClasses,
    labelStyleClasses,
} from '../common/formInputClasses';

const DatePickers = ({ removeMargin = false, ...props }) => {
    return (
        <React.Fragment>
            {!removeMargin ? (
                <div className="form-field">
                    <DateInput {...props} />
                </div>
            ) : (
                <DateInput {...props} />
            )}
        </React.Fragment>
    );
}

export default DatePickers;

const DateInput = ({
    label,
    children,
    field,
    form,
    disabled,
    inputFieldChildren,
    ...props
}) => {

    let isDisabled = disabled ? "disabled" : "";

    return (
        <React.Fragment>
            <label className={labelStyleClasses}> {label} </label>
            <div className={inputFieldClasses}>
                {/* <DatePicker onChange={onChange} value={value} dayPlaceholder='dd'/> */}

                <input
                    type="date"
                    {...field}
                    {...props}
                    tabIndex={props.tabIndex ? props.tabIndex : ""}
                    className={inputFieldStyleClasses}
                    disabled={isDisabled}
                    placeholder="YYYY-MM-DD"
                    max="9999-12-31"
                    
                />

                {inputFieldChildren}
                <RenderIf shouldRender={form && field}>
                    <ErrorMessage form={form} field={field} />
                </RenderIf>
            </div>
            {children}
        </React.Fragment>
    );
};



